import { __awaiter, __generator } from "tslib";
import { backInStockActionsFactory } from './common/backInStockActionsFactory';
export var fetchBackInStockSettings = function (_a) {
    var context = _a.context, origin = _a.origin, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var backinStockActions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, backInStockActionsFactory({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript })];
                case 1:
                    backinStockActions = _a.sent();
                    return [2 /*return*/, backinStockActions.fetchBackInStockSettings()];
            }
        });
    }); };
};
//# sourceMappingURL=fetchBackInStockSettings.js.map